import type { TableColumnType } from "antd";
import moment from "moment";

function getNewDate(action: "antecipar" | "prorrogar", quantidadeDias: number, dataProgramada: string) {
  if (action === "antecipar") {
    return moment(dataProgramada).subtract(quantidadeDias, "days").format("DD/MM/YYYY");
  }
  return moment(dataProgramada).add(quantidadeDias, "days").format("DD/MM/YYYY");
}

function getColumns(action: "antecipar" | "prorrogar", quantidadeDias: number): TableColumnType<any>[] {
  return [
    {
      title: "Talhão",
      dataIndex: "codigo",
      key: "codigo",
      align: "center",
      render: (value: string) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Sequência",
      dataIndex: "sequencia",
      key: "sequencia",
      align: "center",
      render: (value: number) => <span>{value ?? "-"}</span>,
    },
    {
      title: "Data Atual",
      dataIndex: "dataProgramada",
      key: "dataProgramada",
      align: "center",
      render: (value: string) => <span>{value ? moment(value).format("DD/MM/YYYY") : "-"}</span>,
    },
    {
      title: "Nova Data",
      dataIndex: "dataProgramada",
      key: "dataProgramada",
      align: "center",
      render: (value: string) => (
        <span style={{ color: "#4caf50", fontWeight: 600 }}>
          {value ? getNewDate(action, quantidadeDias, value) : "-"}
        </span>
      ),
    },
    {
      title: "Diferença",
      dataIndex: "codigo",
      key: "codigo",
      align: "center",
      render: () => (
        <span style={{ color: action === "antecipar" ? "#00b894" : "#fdcb6e", fontWeight: "bold" }}>
          {action === "antecipar" ? "-" : "+"}{quantidadeDias} dias
        </span>
      ),
    },
  ];
}

export default getColumns;
